export const GetPortfolioInvestmentForm =
  "/Portfolio/GetPortfolioInvestmentForm";

export const GetPortfolioTradeAvgForm = "/Portfolio/GetPortfolioTradeAvgForm";

export const GetPortfolioChart = ({ walletTypeId }) =>
  `/Portfolio/GetPortfolioChart?WalletTypeId=${walletTypeId}`;

export const GetPortfolioTradeAvgList = ({
  walletTypeId,
  dateTypeId,
  startDate,
}) =>
  `/Portfolio/GetPortfolioTradeAvgList?WalletTypeId=${walletTypeId}&DateTypeId=${dateTypeId}&StartDate=${startDate}`;

export const GetPortfolioInvestmentList = ({ dateTypeId, startDate }) =>
  `/Portfolio/GetPortfolioInvestmentList?DateTypeId=${dateTypeId}&StartDate=${startDate}`;

export const GetPortfolioTradeAvgForCoinList = ({
  coinId,
  dateTypeId,
  walletTypeId,
  pageNumber,
  pageSize,
  startDate,
}) =>
  `/Portfolio/GetPortfolioTradeAvgForCoinList?CoinId=${coinId}&WalletTypeId=${walletTypeId}&DateTypeId=${dateTypeId}&PageNumber=${pageNumber}&PageSize=${pageSize}&StartDate=${startDate}`;

export const GetPortfolioTradeAvgForCoinListStartDate = ({
  coinId,
  dateTypeId,
  walletTypeId,
  pageNumber,
  pageSize,
  startDate,
}) =>
  `/Portfolio/GetPortfolioTradeAvgForCoinList?CoinId=${coinId}&WalletTypeId=${walletTypeId}&DateTypeId=${dateTypeId}&StartDate=${startDate}&PageNumber=${pageNumber}&PageSize=${pageSize}`;

export const GetPortfolioTradeAvgForCoin = ({
  coinId,
  dateTypeId,
  walletTypeId,
}) =>
  `/Portfolio/GetPortfolioTradeAvgForCoin?CoinId=${coinId}&WalletTypeId=${walletTypeId}&DateTypeId=${dateTypeId}`;
